/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'multiproducts': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M23.952 32v-8.048H32V32h-8.048zm0-11.976v-8.048H32v8.048h-8.048zM11.976 8.048V0h8.048v8.048h-8.048zM23.952 0H32v8.048h-8.048V0zM11.976 20.024v-8.048h8.048v8.048h-8.048zM0 20.024v-8.048h8.048v8.048H0zM0 32v-8.048h8.048V32H0zm11.976 0v-8.048h8.048V32h-8.048zM0 8.048V0h8.048v8.048H0z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/multiproducts.js